/**
 * Coach notes on a client through the global apiClient. Non-throwing.
 *
 * `silent`: GlobalStateProvider shows its own copy for 429 ("wait N seconds", using `retryAfter`)
 * and 401 ("Session expired") and rolls back its optimistic update — apiClient's toasts would
 * double up.
 */

import { api, type ApiResponse } from '@/lib/apiClient';

export function createNote(body: {
  clientId: string;
  note: string;
  type: string;
  tags: string[];
  pinned: boolean;
  /** Makes a retried create a server-side no-op (`duplicate: true`). */
  idempotencyKey: string;
}): Promise<ApiResponse & { noteId?: string; duplicate?: boolean }> {
  return api.post('/api/notes', body, { silent: true });
}

/** Soft delete. The id goes in the body (DELETE /api/notes takes no path param). */
export function deleteNote(noteId: string): Promise<ApiResponse> {
  return api.request('/api/notes', { method: 'DELETE', body: { noteId }, silent: true });
}
